"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unauthorized = void 0;
const ApiException_1 = require("./ApiException");
class Unauthorized extends ApiException_1.ApiException {
    constructor(message = 'Not authenticated.', data) {
        super(message, data);
    }
}
exports.Unauthorized = Unauthorized;
